module.exports = __webpack_public_path__ + "825dc57856b681ef72fd306cd2070264.pdf";